'use client'

import { useState } from 'react'

export interface LeadFormProps {
  pageId: string
  pageSlug: string
  redirectTo?: string
  buttonText?: string
  primaryColor?: string
  askPhone?: boolean
  askName?: boolean
}

export function LeadForm({
  pageId,
  pageSlug,
  redirectTo,
  buttonText = 'Quero receber',
  primaryColor,
  askPhone = false,
  askName = true,
}: LeadFormProps) {
  const color = primaryColor || '#7C3AED'
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email.trim()) {
      setError('Email e obrigatorio')
      return
    }

    setSubmitting(true)
    setError('')

    try {
      // Capturar UTM params da URL atual
      const urlParams = new URLSearchParams(window.location.search)
      const utm = {
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_content: urlParams.get('utm_content'),
        utm_term: urlParams.get('utm_term'),
      }

      const res = await fetch('/api/p/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page_id: pageId,
          name: name.trim() || null,
          email: email.trim(),
          phone: phone.trim() || null,
          ...utm,
          referrer: document.referrer || null,
        }),
      })

      const data = await res.json()
      if (res.ok) {
        // Redirecionar para thank you page
        if (redirectTo) {
          window.location.href = redirectTo
        } else {
          window.location.href = `/p/obrigado-${pageSlug}`
        }
      } else {
        setError(data.error || 'Erro ao enviar')
        setSubmitting(false)
      }
    } catch {
      setError('Erro de conexao')
      setSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3 max-w-md mx-auto">
      {askName && (
        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Seu nome"
          className="w-full px-4 py-3 bg-white border border-stone-300 rounded-xl text-stone-900 placeholder-stone-400 focus:outline-none focus:ring-2"
          style={{ '--tw-ring-color': color } as React.CSSProperties}
        />
      )}
      <input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="Seu melhor email"
        required
        className="w-full px-4 py-3 bg-white border border-stone-300 rounded-xl text-stone-900 placeholder-stone-400 focus:outline-none focus:ring-2"
        style={{ '--tw-ring-color': color } as React.CSSProperties}
      />
      {askPhone && (
        <input
          type="tel"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          placeholder="WhatsApp (opcional)"
          className="w-full px-4 py-3 bg-white border border-stone-300 rounded-xl text-stone-900 placeholder-stone-400 focus:outline-none focus:ring-2"
          style={{ '--tw-ring-color': color } as React.CSSProperties}
        />
      )}

      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="w-full px-6 py-3 text-white font-bold rounded-xl shadow-lg transition-opacity disabled:opacity-50"
        style={{ backgroundColor: color }}
      >
        {submitting ? 'Enviando...' : buttonText}
      </button>

      <p className="text-xs text-stone-500 text-center">
        Seus dados estao protegidos e nao compartilhamos com terceiros.
      </p>
    </form>
  )
}
